export function generateEventInfosOptions(): uui.domain.ui.list.ListOptions {
  return {
    search: {
      query: '',
      fields: ['type', 'formattedTime'],
      operator: 'or',
      exactMatch: false,
    },
    filter: [],
    sort: [
      {
        field: 'sort.fromNewToOld',
        direction: 'asc',
      },
    ],
    group: [],
  }
}
